
import L from 'leaflet';
import {dataforvalterMapConfig} from './map-config';
import {LEAFLET_EPSG25833_GEODATA} from './NVDBCRS';
import latLng = L.latLng;

export default class Map {
    public leafletMap: L.Map;
    constructor(elementId: HTMLElement) {
        this.leafletMap = L.map(elementId, {
            crs: LEAFLET_EPSG25833_GEODATA,
            worldCopyJump: false,
            center: latLng(62.43, 10.40),
            zoom: 4
        });

        const geodataMap = L.tileLayer('https://nvdbcache.geodataonline.no/arcgis/rest/services/Trafikkportalen/GeocacheTrafikkJPG/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 20,
            minZoom: 3,
            maxNativeZoom: 16,
            attribution: 'NVDB',

        });

        const norkartMap =  L.tileLayer.wms(`/rest/map/webatlas`, {
            layers: 'WEBATLASNorge:Norge',
            format: 'image/png',
            maxZoom: 20,
            minZoom: 0,
            maxNativeZoom: 16,
            attribution: 'Webatlas'
        });

        const norgeIBilder =  L.tileLayer.wms(`https://opencache3.statkart.no/gatekeeper/gk/gk.open_nib_utm33_wmts_v2?layer=Nibcache_UTM33_EUREF89_v2&style=default&tilematrixset=default028mm&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix={z}&TileCol={x}&TileRow={y}`, {
            layers: 'ortofoto',
            format: 'image/png',
            maxZoom: 20,
            minZoom: 0,
            maxNativeZoom: 16,
            attribution: 'GeoNorge'
        });


        const baseMaps  = {
            'Geodata Online': geodataMap,
            //"NiB": nib,
            'Norkart WebAtlas': norkartMap,
            'Norge i Bilder': norgeIBilder
        };

        L.control.layers(baseMaps, null, {collapsed: false, position: 'bottomleft'}).addTo(this.leafletMap);
        this.leafletMap.addLayer(geodataMap);
        this.leafletMap.setView([63.43, 10.40], 4);
    }

    getLeafletMap() {
        return this.leafletMap;
    }

    getBounds() {
        return this.leafletMap.getBounds();
    }
}
